import GroupView from "@/components/GroupView";
import Risques from "@/pages/saas/Risques";
import Controles from "@/pages/saas/Controles";
import Audits from "@/pages/saas/Audits";
import Incidents from "@/pages/saas/Incidents";
import PlansAction from "@/pages/saas/PlansAction";
import Fournisseurs from "@/pages/saas/Fournisseurs";
import Normes from "@/pages/saas/Normes";
import NorthPoints from "@/pages/saas/NorthPoints";

export default function RisqueConformite() {
  return (
    <GroupView
      groupKey="risque-conformite"
      groupLabel="Risque & Conformité"
      overline="Module groupe · GRC"
      tabs={[
        { slug: "risques", label: "Risques", Component: Risques },
        { slug: "controles", label: "Contrôles", Component: Controles },
        { slug: "audits", label: "Audits", Component: Audits },
        { slug: "incidents", label: "Incidents", Component: Incidents },
        { slug: "plans", label: "Plans d'action", Component: PlansAction },
        { slug: "normes", label: "Normes", Component: Normes },
        { slug: "points-nord", label: "Points Nord", Component: NorthPoints },
        { slug: "fournisseurs", label: "Fournisseurs", Component: Fournisseurs },
      ]}
    />
  );
}
